import searchConstants from "../_constants/searchConstants";
import { updateObject } from "../_utils";
import { concat } from "lodash";
import userConstants from "../_constants/userConstants";

const initialState = {
  hasMoreResults: true,
  filter: null,
  lastResult: null,
  results: []
};

const search = (state, action) => {
  return updateObject(state, { results: action.payload });
};
const clearSearchResults = (state, action) => {
  return updateObject(state, { results: [], lastResult: null, filter: null });
};
const changeHasMoreResultsFlag = (state, action) => {
  return updateObject(state, { hasMoreResults: action.payload });
};
const changeLastResult = (state, action) => {
  return updateObject(state, { lastResult: action.payload });
};
const changeFilter = (state, action) => {
  return updateObject(state, { filter: action.payload });
};
const loadMoreSearchResults = (state, action) => {
  return updateObject(state, {
    results: concat(state.results, action.payload)
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH:
      return search(state, action);
    case searchConstants.CLEAR_SEARCH_RESULTS:
      return clearSearchResults(state, action);
    case searchConstants.CHANGE_HAS_MORE_RESULTS_FLAG:
      return changeHasMoreResultsFlag(state, action);
    case searchConstants.CHANGE_LAST_RESULT:
      return changeLastResult(state, action);
    case searchConstants.CHANGE_FILTER:
      return changeFilter(state, action);
    case searchConstants.LOAD_MORE_SEARCH_RESULTS:
      return loadMoreSearchResults(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/searchReducer.js